import React from "react";
import { Flex, Box } from "grid-styled";
import { withTheme } from "styled-components";
import Media from "react-media";
import {
    ScrollView,
    Container,
    Relative,
    Absolute,
    BoxWithHeight
} from "../globals";
import BookList from "../BookList";

const SecondPage = ({ books, theme: { breakpoints } }) => (
    <Media query={`(min-width: ${breakpoints[1]})`}>
        {matches =>
            matches ? (
                <Flex
                    flexDirection="column"
                    flex={1}
                    w={["100%", "100%", "100%", "auto"]}
                >
                    <Relative>
                        <Absolute
                            top={0}
                            bottom={0}
                            left={0}
                            right={0}
                            zIndex={0}
                        >
                            <Flex flexDirection="column" flex={1}>
                                <BoxWithHeight
                                    w={1}
                                    height="100vh"
                                    borderRight="16px solid #7066FF"
                                    borderTop="16px solid #7066FF"
                                    borderBottom="16px solid #7066FF"
                                />
                            </Flex>
                        </Absolute>

                        <Absolute
                            top={0}
                            bottom={0}
                            left={0}
                            right={0}
                            zIndex={0}
                        >
                            <Flex flexDirection="column" flex={1}>
                                <BoxWithHeight
                                    w={96}
                                    height="100vh"
                                    style={{
                                        opacity: 0.25,
                                        background:
                                            "linear-gradient(to left, transparent 0%, rgba(0, 0, 0, 0.075) 75%, rgba(0, 0, 0, 0.15) 85%, rgba(0, 0, 0, 0.3) 98%, rgba(0, 0, 0, 0.6) 100%)"
                                    }}
                                />
                            </Flex>
                        </Absolute>
                    </Relative>

                    <Flex
                        flexDirection="column"
                        flex={1}
                        bg="#EBEBEB"
                        my={4}
                        mr={4}
                        w={["100%", "100%", "100%", "auto"]}
                        style={{ minHeight: 0 }}
                    >
                        <Relative style={{ overflowY: "auto" }}>
                            <ScrollView>
                                <Container
                                    py={[12, 12, 12, 16]}
                                    px={[6, 6, 6, 12]}
                                >
                                    <Relative>
                                        <BookList books={books} />
                                    </Relative>
                                </Container>
                            </ScrollView>
                        </Relative>
                    </Flex>
                </Flex>
            ) : (
                <Relative>
                    <Absolute
                        top={0}
                        bottom={0}
                        left={0}
                        right={0}
                        zIndex={0}
                        style={{ display: "flex" }}
                    >
                        <Flex flexDirection="column" flex={1}>
                            <BoxWithHeight
                                w={1}
                                height="100%"
                                borderLeft="8px solid #7066FF"
                                borderBottom="8px solid #7066FF"
                                borderRight="8px solid #7066FF"
                            />
                        </Flex>
                    </Absolute>
                    <Absolute
                        top={0}
                        bottom={0}
                        left={0}
                        zIndex={0}
                        right={0}
                        style={{ display: "flex" }}
                    >
                        <Flex flexDirection="column" flex={1} w="100vw">
                            <BoxWithHeight
                                w={1}
                                height="48px"
                                style={{
                                    opacity: 0.25,
                                    background:
                                        "linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.075) 75%, rgba(0, 0, 0, 0.15) 85%, rgba(0, 0, 0, 0.3) 98%, rgba(0, 0, 0, 0.6) 100%)"
                                }}
                            />
                        </Flex>
                    </Absolute>
                    <Box pb={2} px={2}>
                        <Container py={[12, 12, 12, 16]} px={[6, 6, 6, 12]}>
                            <Relative>
                                <BookList books={books} />
                            </Relative>
                        </Container>
                    </Box>
                </Relative>
            )
        }
    </Media>
);

export default withTheme(SecondPage);



// WEBPACK FOOTER //
// ./src/components/AnimationController/SecondPage.js